/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */

import { ROUTES } from "@nf/constants";
import type { GetServerSideProps, GetServerSidePropsContext } from "next";
import dynamic from "next/dynamic";

const CollectionScreen = dynamic(
  () => import("screens/CollectionScreen/CollectionScreen")
);

export const getServerSideProps: GetServerSideProps = async (
  ctx: GetServerSidePropsContext
) => {
  const { getCommonServerSideProps } = await import(
    "helpers/getCommonServerSideProps"
  );

  const setCacheHeader = await import("helpers/cacheHeaderHelper").then(
    (mod) => mod.setCacheHeader
  );

  setCacheHeader(ctx.res);

  const { commonProps, DataProvider } = await getCommonServerSideProps(ctx);
  const mediaId = ctx.params?.id?.toString() || -1;
  DataProvider.setCountry(commonProps.country);

  const media = await DataProvider.getMedia({
    MediaId: mediaId,
    IncludeCategories: true,
    IncludeImages: true,
    IncludePeople: true,
    IncludeRecommendedMedia: false,
    IncludeCollections: true,
    IncludeSeoData: true,
    OnlyPublished: false,
    MediaMapperOptions: {
      ExcludeYear: true,
      ExcludeDescription: true,
      ExcludePeople: true,
      ExcludeSeasons: true,
      ExcludeSubtitles: true,
      FirstCategoryOnly: true,
      ExcludeProducts: false,
      ExcludeImagesFromCategories: true,
      ExcludeMediaAgeRestrictionValueMin: true,
      ExcludeImageType: ["HERO_FRONTPAGE", "BANNER", "THUMBNAIL", "COVER"],
    },
  });

  const PAGE_SIZE = 25;
  if (media?.Media && media?.Media?.length > PAGE_SIZE) {
    media.Media = media.Media.slice(0, PAGE_SIZE);
  }

  if (commonProps?.isChild && media?.ContentAdvisory) {
    return {
      redirect: {
        destination: `/${commonProps.country}/${commonProps.lang}${ROUTES.KIDS}`,
      },
      props: {
        ...commonProps,
      },
    };
  }

  return {
    props: {
      ...commonProps,
      media,
    },
  };
};

export default CollectionScreen;
